import { defineStore } from 'pinia'

import { createAccountActions } from './actions.account'
import { createAuthActions } from './actions.auth'
import { createProfileActions } from './actions.profile'
import { createUserState } from './state'

export const useUserStore = defineStore('user', () => {
    const state = createUserState()

    const auth = createAuthActions(state)
    const profile = createProfileActions(state)
    const account = createAccountActions()

    return {
        // State
        token: state.token,
        userId: state.userId,
        userName: state.userName,
        userEmail: state.userEmail,
        user: state.user,
        permissionsReceived: state.permissionsReceived,
        permissions: state.permissions,
        loggedIn: state.loggedIn,

        // Actions
        ...auth,
        ...profile,
        ...account
    }
})
